import { CloudDownload, GitHub, Instagram, Telegram } from '@mui/icons-material';
import vetTex from '../img/image.png'
import legscyHomes from '../img/Screenshot 2024-07-11 030800.png'
import plant from '../img/Screenshot 2024-07-11 035221.png'
import auto from '../img/Screenshot 2024-07-11 042001.png'

export const projects = [
    {
        id: 1,
        linkName: 'Vet Tex Shifo',
        slug: 'http://vet-texshifo.uz',
        description: 'A website for the veterinary clinic "Vet Tex Shifo". Here you can find information about services provided, specialists, and make online appointments.',
        image: vetTex,
        svg: <svg width="108" height="24" viewBox="0 0 108 24" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M107.061 13.0607C107.646 12.4749 107.646 11.5251 107.061 10.9393L97.5147 1.3934C96.9289 0.807611 95.9792 0.807611 95.3934 1.3934C94.8076 1.97918 94.8076 2.92893 95.3934 3.51472L103.879 12L95.3934 20.4853C94.8076 21.0711 94.8076 22.0208 95.3934 22.6066C95.9792 23.1924 96.9289 23.1924 97.5147 22.6066L107.061 13.0607ZM106 10.5L7.76053e-06 10.5L7.49826e-06 13.5L106 13.5L106 10.5Z" fill="#0EE6B7" />
        </svg>
    },
    {
        id: 2,
        linkName: 'Legacy Homes',
        slug: 'https://legacy-homes.netlify.app/',
        description: 'A modern real estate website "Legacy Homes". Browse various real estate listings, get detailed information, and contact agents for further details.',
        image: legscyHomes,
        svg: <svg width="108" height="24" viewBox="0 0 108 24" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M107.061 13.0607C107.646 12.4749 107.646 11.5251 107.061 10.9393L97.5147 1.3934C96.9289 0.807611 95.9792 0.807611 95.3934 1.3934C94.8076 1.97918 94.8076 2.92893 95.3934 3.51472L103.879 12L95.3934 20.4853C94.8076 21.0711 94.8076 22.0208 95.3934 22.6066C95.9792 23.1924 96.9289 23.1924 97.5147 22.6066L107.061 13.0607ZM106 10.5L7.76053e-06 10.5L7.49826e-06 13.5L106 13.5L106 10.5Z" fill="#0EE6B7" />
        </svg>
    },
    {
        id: 3,
        linkName: 'Plants Shop',
        slug: 'https://plantlanding.netlify.app/',
        description: 'An online store for plant lovers. "Plants Shop" offers a wide range of indoor and garden plants, as well as related care products.',
        image: plant,
        svg: <svg width="108" height="24" viewBox="0 0 108 24" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M107.061 13.0607C107.646 12.4749 107.646 11.5251 107.061 10.9393L97.5147 1.3934C96.9289 0.807611 95.9792 0.807611 95.3934 1.3934C94.8076 1.97918 94.8076 2.92893 95.3934 3.51472L103.879 12L95.3934 20.4853C94.8076 21.0711 94.8076 22.0208 95.3934 22.6066C95.9792 23.1924 96.9289 23.1924 97.5147 22.6066L107.061 13.0607ZM106 10.5L7.76053e-06 10.5L7.49826e-06 13.5L106 13.5L106 10.5Z" fill="#0EE6B7" />
        </svg>
    },
    {
        id: 4,
        linkName: 'Auto Essentials',
        slug: 'https://auto-essentials.netlify.app/',
        description: 'An online store for automotive accessories "Auto Essentials". Find everything you need for your car – from seat covers and floor mats to high-tech gadgets and tools.',
        image: auto,
        svg: <svg width="108" height="24" viewBox="0 0 108 24" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M107.061 13.0607C107.646 12.4749 107.646 11.5251 107.061 10.9393L97.5147 1.3934C96.9289 0.807611 95.9792 0.807611 95.3934 1.3934C94.8076 1.97918 94.8076 2.92893 95.3934 3.51472L103.879 12L95.3934 20.4853C94.8076 21.0711 94.8076 22.0208 95.3934 22.6066C95.9792 23.1924 96.9289 23.1924 97.5147 22.6066L107.061 13.0607ZM106 10.5L7.76053e-06 10.5L7.49826e-06 13.5L106 13.5L106 10.5Z" fill="#0EE6B7" />
        </svg>
    }
];

export const technologies = [
    {
        id: 1,
        title: 'Html',
        subtitle: 'Advanced',
        width: '75%'
    },
    {
        id: 2,
        title: 'CSS, Sass',
        subtitle: 'Advanced',
        width: '75%'
    },
    {
        id: 3,
        title: 'JavaScript, React.Js',
        subtitle: 'Regular',
        width: '50%'
    },
    {
        id: 4,
        title: 'jQuery, Gulp, TypeScript',
        subtitle: 'Beginner',
        width: '25%'
    },
];

export const subTechno = [
    {
        title: 'GitHub'
    },
    {
        title: 'Redux'
    },
    {
        title: 'RTK Query'
    },
    {
        title: 'Figma'
    },
    {
        title: 'Tailwind CSS'
    },
    {
        title: 'Material UI'
    },
    {
        title: 'Teamwork'
    },
    {
        title: 'Quick learning'
    },
];

export const social = [
    {
        title: 'GitHub',
        slug: 'https://github.com/Kahramonovvich',
        icon: <GitHub />
    },
    {
        title: 'Telegram',
        slug: 'https://t.me/kahramonovvich',
        icon: <Telegram />
    },
    {
        title: 'Instagram',
        slug: 'https://www.instagram.com/kahramonovvich',
        icon: <Instagram />
    },
    {
        title: 'Resume',
        slug: '/resume/resume.pdf',
        icon: <CloudDownload />,
        download: 'resume.pdf'
    },
];

export const navMenu = [
    {
        linkName: 'About',
        slug: '#about'
    },
    {
        linkName: 'Projects',
        slug: '#projects'
    },
    {
        linkName: 'Technologies',
        slug: '#technologies'
    },
    {
        linkName: 'Contact',
        slug: '#contact'
    },
];